export interface FindJourneyParams {
  date?: string;
  vehicle_id?: string;
  partner_id?: string;
}
